"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors = {
    primary: {
        $300: "#3DBDE1",
        $400: "#2EA5C8",
        $500: "#0092bc",
        $600: "#00789A",
        $700: "#005D78"
    },
    secondary: {
        $300: "#CC5CB7",
        $400: "#BE2EA2",
        $500: "#b0008e",
        $600: "#910075",
        $700: "#71005B"
    },
    success: {
        $300: "#5CD684",
        $400: "#2ECA61",
        $500: "#00bf3f",
        $600: "#009D34",
        $700: "#007A29"
    },
    danger: {
        $300: "#FA7D82",
        $400: "#F9585F",
        $500: "#f8333c",
        $600: "#CB2A32",
        $700: "#9E2127"
    },
    warning: {
        $300: "#FEDC5C",
        $400: "#FED22E",
        $500: "#FEC800",
        $600: "#D0A400",
        $700: "#A28000"
    },
    gray: {
        $000: "#ffffff",
        $010: "#f8f8f8",
        $025: "#f0f0f0",
        $050: "#e6e6e6",
        $100: "#d1d1d1",
        $200: "#bcbcbc",
        $300: "#a8a8a8",
        $400: "#949494",
        $500: "#818181",
        $600: "#6e6e6e",
        $700: "#595959",
        $800: "#424242",
        $900: "#1d1e25"
    }
};
exports.default = colors;
//# sourceMappingURL=index.js.map